import EntradaReportes from "../../componentes/EntradaReportes/EntradaReportes";
import { useState } from "react";
import { Dialog } from 'primereact/dialog';
import { PERMISOS, puedeAcceder } from "../../servicios/sesionSeguridad";


export default function EntradasReporte() {
  const [Visible, setVisible] = useState(false);
  const Cargar = () => { }
  if (!puedeAcceder(PERMISOS.REPORTES_VER)) return null;
  return (
    <div>
      <button className="reportes-contenedor" onClick={() => setVisible(true)}>
        <i className="pi pi-chart-bar" aria-hidden="true" /><span>Reportes</span>
      </button>

      <Dialog header={<h3>Reporte Entradas</h3>} position='center' visible={Visible}
        style={{ width: '80vw', height: '80vh' }} maximizable={true}
        contentStyle={{ backgroundColor: "white" }}
        closable={true}
        onShow={Cargar}
        onHide={() => setVisible(false)} >
        <EntradaReportes />
      </Dialog>

    </div>
  )
}
